import React, { useState } from 'react'

import { Button, Divider, Icon, Modal, Select, Tooltip } from 'antd'
import differenceWith from 'lodash/differenceWith'
import get from 'lodash/get'

import ConfirmModal from '../../../../../../ConfirmModal'

const ReassignTeamSelect = props => {
  const member = get(props, 'member')
  const teams = get(props, 'teams')
  const handleRemoveMemberClick = get(props, 'handleRemoveMemberClick')
  const reassignTeamMember = get(props, 'reassignTeamMember')

  const teamsAreEqual = (team1, team2) => team1.id === team2.id

  // teams of which the user is not a member
  const availableTeams = differenceWith(teams, get(member, 'teams'), teamsAreEqual)

  const [reassignModalVisible, setReassignModalVisible] = useState(false)
  const [removeModalVisible, setRemoveModalVisible] = useState(false)
  const [teamSelectedForAssignment, setTeamSelectedForReassignment] = useState(null)

  const selectTeam = teamName => {
    const selectedTeam = teams.find(team => team.name === teamName)
    setTeamSelectedForReassignment(selectedTeam)
  }

  const handleReassignConfirm = () => {
    const newTeamId = get(teamSelectedForAssignment, 'id')
    reassignTeamMember(member, newTeamId)
    setReassignModalVisible(false)
    setTeamSelectedForReassignment(null)
  }

  const handleReassignCancel = () => {
    setReassignModalVisible(false)
    setTeamSelectedForReassignment(null)
  }

  return (
    <>
      <Button
        style={{ padding: 0 }}
        className="false-anchor"
        onClick={() => setReassignModalVisible(true)}
        aria-label={`Reassign member ${member.firstName} ${member.lastName}`}
      >
        Reassign
      </Button>
      <Modal
        centered
        okButtonProps={{ disabled: !teamSelectedForAssignment }}
        okText="Reassign"
        onCancel={handleReassignCancel}
        onOk={handleReassignConfirm}
        title={`Reassign ${get(member, 'firstName')} ${get(member, 'lastName')}`}
        visible={reassignModalVisible}
      >
        <Select
          aria-label="Select a team to reassign to"
          disabled={!availableTeams.length}
          onChange={teamName => selectTeam(teamName)}
          suffixIcon={<Icon aria-hidden="true" type="down" />}
          placeholder={!availableTeams.length ? 'No available teams' : 'Select a team'}
          style={{ width: '100%' }}
          value={get(teamSelectedForAssignment, 'name') || undefined}
        >
          {availableTeams.map(team => {
            const teamName = get(team, 'name')
            return (
              <Select.Option key={teamName} value={teamName} aria-label={teamName}>
                {teamName}
              </Select.Option>
            )
          })}
        </Select>
      </Modal>
      <Divider aria-hidden="true" type="vertical" />
      {member.warning ? (
        <Tooltip title="This member is only part of this team. Please reassign user to another team.">
          <Button
            disabled
            type="link"
            aria-label={`Remove member ${member.firstName} ${member.lastName}. This member is only part of this team. Please reassign user to another team.`}
          >
            Remove
          </Button>
        </Tooltip>
      ) : (
        <>
          <Button
            style={{ padding: 0 }}
            className="false-anchor"
            onClick={() => setRemoveModalVisible(true)}
            aria-label={`Remove member ${member.firstName} ${member.lastName}`}
          >
            Remove
          </Button>
          <ConfirmModal
            onCancel={() => setRemoveModalVisible(false)}
            onConfirm={() => {
              handleRemoveMemberClick(member)
              setRemoveModalVisible(false)
            }}
            title={`Remove ${member.firstName}?`}
            visible={removeModalVisible}
          />
        </>
      )}
    </>
  )
}

export default ReassignTeamSelect
